import { render, staticRenderFns } from "./ViewBuilding.vue?vue&type=template&id=cee03e3e&scoped=true&"
import script from "./ViewBuilding.vue?vue&type=script&lang=js&"
export * from "./ViewBuilding.vue?vue&type=script&lang=js&"
import style0 from "./ViewBuilding.vue?vue&type=style&index=0&id=cee03e3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee03e3e",
  null
  
)

export default component.exports